import 'core-js/stable';
import 'regenerator-runtime/runtime';
require('array.prototype.find');
import 'es6-promise';
import assign from 'object-assign';

Object.assign = assign;

// Remove all Enzyme imports - they should only be in test files
